import { FC, Fragment } from "react";
import { Modal, Box, Typography, IconButton, Button } from "@mui/material";
import { buttonArrType, ModalLayoutType } from "DataTypes/Layout.type";
import ImgPath from "Constants/Imgs";

const ModalLayout: FC<ModalLayoutType> = (props: ModalLayoutType) => {
  const { modheight, modwidth, heading, content, open, onClose, buttonArr } =
    props;
  const body = (
    <Box
      sx={{
        ...sxMain,
        backgroundColor: "common.white",
        boxShadow: "0px 0px 6px #00000029",
        borderRadius: 1.25,
        width: "50%",
      }}
    >
      {heading && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            ...sxHead,
            justifyContent: "space-between",
            height: "3rem",
          }}
        >
          <Typography
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              "&>svg": {
                mr: 1,
              },
            }}
          >
            {heading}
          </Typography>
          {onClose && (
            <IconButton onClick={onClose}>
              <ImgPath.CloseIcon />
            </IconButton>
          )}
        </Box>
      )}
      <Box
        sx={{
          height: heading ? "calc(100% - 6rem)" : "calc(100% - 6rem)",
          p: 2,
        }}
      >
        {content}
      </Box>
      {buttonArr && (
        <Box
          sx={{
            px: 2,
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            height: "3rem",
          }}
        >
          {buttonArr.map((el: buttonArrType) => {
            return (
              <Fragment key={el.id}>
                <Button
                  sx={{ mr: 1, mb: 1 }}
                  onClick={el.clickHandler}
                  variant={el.type === "border" ? "outlined" : "contained"}
                  disabled={el?.disable}
                >
                  {el.label}
                </Button>
              </Fragment>
            );
          })}
        </Box>
      )}
    </Box>
  );

  return (
    <div>
      <Modal
        open={open}
        {...(onClose && { onClose: onClose })}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
};

export default ModalLayout;

const sxMain = {
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  transform: `translate(-${50}%, -${50}%)`,
  position: "absolute",
  outline: "none",
  // overflow: "auto",
  borderRadius: 1.25,
};

const sxHead = {
  backgroundColor: "primary.main",
  px: 2,
  "& >p:first-of-type": {
    color: "white",
  },
  "& >button": {
    color: "white",
  },
};
